<div [class.bright]="isBright">
    <div class="main_content">
        <app-breadcrumb></app-breadcrumb>
        <div class="page_main_sec">
            <div class="row legend-sec">
                <div class="col-lg-6 ">
                    <span class="form-field-legend">
                        <font color="red">* Fields are Mandatory</font>
                    </span>
                    <!-- <span class="form-field-legend">
                        <font color="blue"># Fields are Numeric</font>
                    </span> -->
                    <span class="form-field-legend">
                        <font color="green">## Fields are Decimal</font>
                    </span>
                </div>
                <div class="col-lg-2 text-center doctype-wrap">
                    <span>
                        <small>Work Item Type</small>
                        <i class="material-icons" title="Edit"
                            (click)="isOpenDoctypeModel = true;showModal(documentTypeModal,'sm', 'doctype')">edit</i>
                    </span>
                    <br />
                    <span class=" doctype-name">{{ selectedDocumentType.docTypeName }}</span>
                </div>

            </div>


            <div class="form-container">


                <div class="row form-control-sec DAO_datacss">

                    <mat-tab-group #tabGroupmain mat-stretch-tabs="true" mat-align-tabs="start">
                        <mat-tab label="Manual Upload">

                            <div class="row form-control-sec comment-box-main">

                                <h4 class="title_css_doa">Add DOA Data</h4>

                                <div class="col-lg-3">
                                    <div style="display: flex;">
                                        <mat-form-field [style.width.%]="100">
                                            <mat-label for="approver_selection">Select Approver Name<span
                                                    class="field-mandatory">*</span></mat-label>
                                            <mat-select #approvermenu [(value)]="Approvernm" [(ngModel)]="Approvernm"
                                                id="approver_selection">
                                                <mat-option [value]="doc.ApproverId" *ngFor="let doc of ApproverList">
                                                    {{doc.ApproverName}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error>Please select approver </mat-error>


                                        </mat-form-field>
                                        <button mat-button matSuffix mat-icon-button>
                                            <mat-icon class="searchiconcss"
                                                (click)="showModal(UserDetailsModal,'lg', 'Approver'); approvermenu.close()">search</mat-icon>
                                        </button>

                                    </div>


                                </div>


                                <div class="col-lg-3">
                                    <mat-form-field [style.width.%]="100">
                                        <mat-label for="level_of_approver">Level of Approver<span
                                                class="field-mandatory">*</span></mat-label>
                                        <input matInput type="number" min="1" max="100" step="1"
                                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                                            placeholder="1" value="" [(ngModel)]="Levelval" id="level_of_approver">
                                        <mat-error>Please enter a value greater than 0</mat-error>
                                    </mat-form-field>
                                </div>


                                <div class="col-lg-3" style="display: none;">
                                    <div style="display: flex;">
                                        <mat-form-field [style.width.%]="100">
                                            <mat-label for="manager_selection">Select Manager Name</mat-label>
                                            <mat-select [(value)]="Managernm" [(ngModel)]="Managernm"
                                                id="manager_selection">
                                                <mat-option [value]="doc.ApproverId" *ngFor="let doc of ApproverList">
                                                    {{doc.ApproverName}}
                                                </mat-option>
                                            </mat-select>

                                        </mat-form-field>
                                        <button mat-button matSuffix mat-icon-button>
                                            <mat-icon class="searchiconcss"
                                                (click)="showModal(UserDetailsModal,'lg', 'Manager')">search</mat-icon>
                                        </button>
                                    </div>
                                </div>



                                <div [formGroup]=frmInvoice *ngIf="frmInvoice">






                                    <div class="row">
                                        <div *ngFor="let field of DOA_Datafieldlist" [ngSwitch]="field.control_type"
                                            class="col-lg-{{field.control_type=='TEXTAREA'?6:3}}">
                                            <mat-form-field *ngSwitchCase="'TEXTBOX'" [style.width.%]="100">
                                                <mat-label>
                                                    {{ field.field_name }}
                                                    <span *ngIf="field.is_mandatory == 1"
                                                        class="field-mandatory">*</span>
                                                    <span
                                                        *ngIf="field.validation_type == 'NUMERIC' &&  field.precision_point<=0"
                                                        class="field-numeric">#</span>
                                                    <span
                                                        *ngIf="(field.validation_type == 'NUMERIC' || field.validation_type == 'AMOUNT') &&  field.precision_point>0 "
                                                        class="field-decimal">##</span>
                                                </mat-label>

                                                <input matInput
                                                    *ngIf="field.value_type=='text' && field.validation_type != 'AMOUNT'"
                                                    [type]="field.value_type" [formControlName]="field.db_column_name"
                                                    (keydown.enter)="submitInvoice()"
                                                    (change)="changeTextFieldValue(field)"
                                                    (keypress)="omit_special_char($event,field.valid_input_regexp);" />

                                                <input matInput *ngIf="field.value_type=='number'" class="text-end"
                                                    (keypress)="onTextBoxKeyPressEvent($event,field)"
                                                    [type]="field.value_type" [formControlName]="field.db_column_name"
                                                    (keydown.enter)="submitInvoice()"
                                                    (change)="changeTextFieldValue(field)"
                                                    (keypress)="omit_special_char($event,field.valid_input_regexp);" />

                                                <input matInput *ngIf="field.validation_type == 'AMOUNT'"
                                                    class="text-end" (blur)="commonService.formatCurrencyValue($event)"
                                                    [type]="field.value_type" [formControlName]="field.db_column_name"
                                                    (keydown.enter)="submitInvoice()"
                                                    (change)="changeTextFieldValue(field)"
                                                    (keypress)="omit_special_char($event,field.valid_input_regexp);" />

                                                <button *ngIf="field.is_magnify_search == 1" mat-button matSuffix
                                                    mat-icon-button
                                                    (click)="openAdvanceSearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields,field.predefined_table_column_name)">
                                                    <mat-icon>search</mat-icon>
                                                </button>
                                                <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                                    {{ field.field_name }} is required.
                                                </mat-error>
                                            </mat-form-field>
                                            <div *ngSwitchCase="'DROPDOWN'">
                                                <mat-form-field appearance="legacy" *ngIf="field.is_autocomplete != 1"
                                                    [style.width.%]="100">
                                                    <mat-label for="{field.db_column_name}">
                                                        {{ field.field_name }}
                                                        <span *ngIf="field.is_mandatory == 1"
                                                            class="field-mandatory">*</span>
                                                    </mat-label>
                                                    <mat-select [formControlName]="field.db_column_name"
                                                        (click)="searchText.focus()" (focus)="searchText.focus()"
                                                        (closed)="searchText.value=''"
                                                        (selectionChange)="changeDropdownFieldValue(field)"
                                                        [id]="field.db_column_name">
                                                        <input (keydown)="$event.stopPropagation()" type="search"
                                                            #searchText autocomplete="off" class="mat-select-search"
                                                            placeholder="Search {{field.field_name}}">
                                                        <mat-option [value]="option.id"
                                                            *ngFor="let option of field.options | listFilter:{'name':searchText.value}">
                                                            {{ option.name }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <button *ngIf="field.is_magnify_search == 1" mat-button matSuffix
                                                        mat-icon-button
                                                        (click)="$event.stopPropagation();openAdvanceSearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields)">
                                                        <mat-icon>search</mat-icon>
                                                    </button>
                                                    <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                                        {{ field.field_name }} is required.
                                                    </mat-error>
                                                </mat-form-field>

                                                <app-autocomplete matInput *ngIf="field.is_autocomplete == 1"
                                                    [field]="field" [formControlName]="field.db_column_name"
                                                    [defaultValue]="field.field_v"
                                                    (callOnAutoCompleteChangedEvent)="callOnAutoCompleteChangedEvent(field)">
                                                </app-autocomplete>
                                            </div>

                                            <mat-form-field *ngSwitchCase="'DATE'" [style.width.%]="100">
                                                <mat-label for="{field.db_column_name}">
                                                    {{ field.field_name }}
                                                    <span *ngIf="field.is_mandatory == 1"
                                                        class="field-mandatory">*</span>
                                                </mat-label>
                                                <input matInput readonly [min]="commonService.minDate"
                                                    [formControlName]="field.db_column_name" [matDatepicker]="picker"
                                                    (keydown.enter)="submitInvoice()" [id]="field.db_column_name" />
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                                <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                                    {{ field.field_name }} is required.
                                                </mat-error>
                                            </mat-form-field>

                                            <div *ngSwitchCase="'FILE'" [style.width.%]="100">
                                                <mat-hint align="end">
                                                    Valid Files:{{invoiceDocValidFileExtensions.join('/ ')}} | Max.
                                                    Size:
                                                    {{invoiceDocFileSize}}MB
                                                </mat-hint>
                                                <span class="text-danger">*</span>
                                                <mat-toolbar (click)="invFileUpload_data.click()">
                                                    <div class="form-group">
                                                        <div class="input-group">
                                                            <input type="text" class="form-control fileuploadinput"
                                                                [formControlName]="field.db_column_name" readonly>
                                                            <div class="input-group-btn">
                                                                <span class="fileUpload btn blueupload">
                                                                    <span class="upl" id="upload">Upload Invoice
                                                                    </span>
                                                                    <input [attr.type]="fileControlType"
                                                                        class="upload up" id="up" #invFileUpload_data
                                                                        hidden />
                                                                    <!-- (change)="onSelectExcelFile($event)" -->

                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </mat-toolbar>
                                            </div>

                                            <mat-form-field *ngSwitchCase="'TEXTAREA'" [style.width.%]="100">
                                                <mat-label for="{field.db_column_name}">
                                                    {{ field.field_name }}
                                                    <span *ngIf="field.is_mandatory == 1"
                                                        class="field-mandatory">*</span>
                                                </mat-label>
                                                <textarea matInput #fieldComments [id]="field.db_column_name"
                                                    [formControlName]="field.db_column_name" rows="3" maxlength="500"
                                                    (change)="changeTextFieldValue(field)"></textarea>
                                                <mat-hint align="end">
                                                    maximum {{ fieldComments.value?.length || 0 }} /500 charactors
                                                </mat-hint>
                                                <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                                    {{ field.field_name }} is required.
                                                </mat-error>
                                            </mat-form-field>

                                            <div *ngSwitchCase="'CHECKBOX'" [style.width.%]="100">
                                                <mat-checkbox [formControlName]="field.db_column_name">
                                                    {{ field.field_name }}
                                                </mat-checkbox>
                                            </div>
                                        </div>
                                    </div>



                                    <div class="row mt_20">
                                        <div class="col-lg-4">


                                            <label>Comments <span class="field-mandatory">*</span></label>
                                            <div class="cmnt_textarea_sec"
                                                [ngClass]="isCommentExpand_createdoa?'expanded_textarea':''">
                                                <span class="textarea_font_sec" title="Show list of restricted keywords"
                                                    (click)="showModal_gen(restrictedKeywordModal,'sm')">
                                                    <img src="../../../assets/img/transaction/info.png" alt="Info">
                                                </span>
                                                <span class="expand_textarea_sec" title="Max/Min"
                                                    (click)="isCommentExpand_createdoa = !isCommentExpand_createdoa">
                                                    <img src="../../../assets/img/transaction/expand.png" alt="Expand">
                                                </span>
                                                <span class="textarea_editor_main_sec">
                                                    <span class="words_count_limit">
                                                        {{wordsTotal_createdoa}}
                                                    </span>
                                                </span>
                                                <textarea class="cmnt_textarea" maxlength="1000" required
                                                    [(ngModel)]="createComment"
                                                    (keyup)="function(createComment, 'create')"
                                                    formControlName="commentsection"
                                                    (blur)="checkRestrictedKeywords(createComment,true)">{{createComment}}</textarea>


                                            </div>

                                        </div>
                                        <div class="col-lg-4"></div>

                                        <div class="col-lg-4 text-right" style="margin-top: 30px;">
                                            <button type="button" class="btncss me-2 btn_secondary"
                                                (click)="onResetButtonClick()">
                                                Reset
                                            </button>
                                            <button class="btncss" [class.btn_disable]="frmInvoice?.invalid"
                                                [class.btn_primary]="!frmInvoice?.invalid"
                                                [disabled]="frmInvoice?.invalid"
                                                (click)="submitInvoice()">Submit</button>
                                        </div>
                                    </div>


                                </div>

                            </div>


                            <div class="row form-control-sec DAO_datacss">
                                <div style="float: right;">
                                    <i class="material-icons icon_css_sr" (click)="searchview()"
                                        title="Advance Search">search</i><br />
                                    <div class="grid_panel" *ngIf="isShown">
                                        <app-create-doa-filter [data_field]="workItemFieldList"
                                            (cellClickEvent)="onSearchfilterClick($event)">
                                        </app-create-doa-filter>
                                    </div>
                                </div>

                                <mat-tab-group #tabGroup mat-stretch-tabs="true" mat-align-tabs="start"
                                    (selectedTabChange)="tabChanged($event)">
                                    <mat-tab [label]="reportName">
                                        <div class="row selection-sec">
                                            <div class="grid_panel">
                                                <app-basic-gridview [lstData]="lstData" [columnsToHide]="columnsToHide"
                                                    gridTitle="DOA Data" [showExcelDownloadOption]="true"
                                                    [showSearchOption]="true" [showRecordsPerPageOption]="true"
                                                    [showPagination]="true" (cellClickEvent)="onGridCellClick($event)"
                                                    [hyperlinkCols]="hyperlinkCols" [columnsToExcludeFromExport]="[]">
                                                </app-basic-gridview>
                                            </div>
                                        </div>
                                    </mat-tab>
                                    <mat-tab [label]="reportName_pending">
                                        <div class="row selection-sec">
                                            <div class="grid_panel">
                                                <app-basic-gridview [lstData]="lstData_pending"
                                                    [columnsToHide]="columnsToHide" gridTitle="Pending Request"
                                                    [showExcelDownloadOption]="true" [showSearchOption]="true"
                                                    [showRecordsPerPageOption]="true" [showPagination]="true"
                                                    (cellClickEvent)="onGridCellClick($event)"
                                                    [hyperlinkCols]="hyperlinkCols" [columnsToExcludeFromExport]="[]">
                                                </app-basic-gridview>
                                            </div>
                                        </div>
                                    </mat-tab>

                                    <mat-tab [label]="reportName_rejected">
                                        <div class="row selection-sec">
                                            <div class="grid_panel">
                                                <app-basic-gridview [lstData]="lstData_rejected"
                                                    [columnsToHide]="columnsToHide" gridTitle="Rejected Request"
                                                    [showExcelDownloadOption]="true" [showSearchOption]="true"
                                                    [showRecordsPerPageOption]="true" [showPagination]="true"
                                                    (cellClickEvent)="onGridCellClick($event)"
                                                    [hyperlinkCols]="hyperlinkCols" [columnsToExcludeFromExport]="[]">
                                                </app-basic-gridview>
                                            </div>
                                        </div>
                                    </mat-tab>
                                    <mat-tab [label]="reportName_audited">
                                        <div class="row selection-sec">
                                            <div class="grid_panel">
                                                <app-basic-gridview [lstData]="lstData_audited"
                                                    [columnsToHide]="columnsToHide" gridTitle="History Details"
                                                    [showExcelDownloadOption]="true" [showSearchOption]="true"
                                                    [showRecordsPerPageOption]="true" [showPagination]="true"
                                                    (cellClickEvent)="onGridCellClick($event)"
                                                    [hyperlinkCols]="hyperlinkCols" [columnsToExcludeFromExport]="[]">
                                                </app-basic-gridview>
                                            </div>
                                        </div>
                                    </mat-tab>

                                    <mat-tab [label]="reportName_inactive">
                                        <div class="row selection-sec">
                                            <div class="grid_panel">
                                                <app-basic-gridview [lstData]="lstData_inactive"
                                                    [columnsToHide]="columnsToHide" gridTitle="Inactive DOA Data"
                                                    [showExcelDownloadOption]="true" [showSearchOption]="true"
                                                    [showRecordsPerPageOption]="true" [showPagination]="true"
                                                    (cellClickEvent)="onGridCellClick($event)"
                                                    [hyperlinkCols]="hyperlinkCols" [columnsToExcludeFromExport]="[]">
                                                </app-basic-gridview>
                                            </div>
                                        </div>
                                    </mat-tab>
                                </mat-tab-group>





                            </div>

                        </mat-tab>
                        <mat-tab label="Bulk Upload">
                            <div class="row selection-sec">
                                <div class="grid_panel">

                                    <div class="pd_10 ">
                                        <div class="col-lg-12  align_right" style="float:right"
                                            (click)="downloadExcelTemplate()">
                                            <span class="download-template-wrp">
                                                <span><i class="material-icons">file_download</i></span> Download
                                                Template
                                            </span>
                                        </div>
                                        <br />



                                        <div class="row cart-section">
                                            <div class="col-lg-10">
                                                <div class="fileUploadTitle">
                                                    <span>Upload Excel File</span>
                                                </div>
                                                <div [style.width.%]="100">
                                                    <mat-toolbar class="matBG">
                                                        <input type="text" [hidden]="true">
                                                        <mat-label [attr.title]="fileTitle"
                                                            class="file-names">{{selectedExcelFile}}</mat-label>
                                                        <button class="Mat_btn_Custom_Width" type="button"
                                                            mat-flat-button color="primary"
                                                            (click)="invFileUpload.click()"
                                                            [disabled]="!selectedDocumentType">
                                                            Choose file
                                                        </button>
                                                    </mat-toolbar>
                                                    <input [attr.type]="fileControlType" #invFileUpload
                                                        (change)="onSelectExcelFile($event)" hidden />
                                                </div>




                                            </div>



                                            <div class="col-lg-4">

                                                <label>Comments <span class="field-mandatory">*</span></label>
                                                <!-- <div class="">

                                                    
                                                </div> -->

                                                <div class="cmnt_textarea_sec"
                                                    [ngClass]="isCommentExpand_createdoa_bulk?'expanded_textarea':''">
                                                    <span class="textarea_font_sec"
                                                        title="Show list of restricted keywords"
                                                        (click)="showModal_gen(restrictedKeywordModal,'sm')">
                                                        <img src="../../../assets/img/transaction/info.png" alt="Info">
                                                    </span>
                                                    <span class="expand_textarea_sec" title="Max/Min"
                                                        (click)="isCommentExpand_createdoa_bulk = !isCommentExpand_createdoa_bulk">
                                                        <img src="../../../assets/img/transaction/expand.png"
                                                            alt="Expand">
                                                    </span>
                                                    <span class="textarea_editor_main_sec">
                                                        <span class="words_count_limit">
                                                            {{wordsTotal_createdoa_bulk}}
                                                        </span>
                                                    </span>
                                                    <textarea class="cmnt_textarea" maxlength="1000" required
                                                        [(ngModel)]="createComment_bulk"
                                                        (keyup)="function(createComment_bulk, 'create_bulk')"
                                                        (blur)="checkRestrictedKeywords(createComment_bulk,true)">{{createComment_bulk}}</textarea>

                                                </div>

                                            </div>
                                            <div class="row">
                                                <div class="col-lg-12 pd_top_25">
                                                    <div class="textCenter">
                                                        <button class="waves-effect waves-light btn smallButton"
                                                            (click)="saveDOAData()">
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <br />
                                    </div>

                                </div>
                            </div>

                            <div class="row selection-sec">
                                <div class="grid_panel">
                                    <app-basic-gridview [lstData]="lstData_DOAupload"
                                        [columnsToHide]="columnsToHide_DOAupload" gridTitle="DOA Upload"
                                        [showExcelDownloadOption]="true" [showSearchOption]="true"
                                        [showRecordsPerPageOption]="true" [showPagination]="true"
                                        (cellClickEvent)="onGridCellClick($event)"
                                        [hyperlinkCols]="hyperlinkCols_DOAupload" [columnsToExcludeFromExport]="[]">
                                    </app-basic-gridview>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>

        </div>

    </div>
</div>


<ng-template #documentTypeModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Select Work Item Type</h5>
            <button type="button" class="close model_close_btn"
                (click)="isOpenDoctypeModel = false;modalReference.close()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <ul class="selection-list">
                    <li [class.selected]="selectedDocumentType.docTypeId == docType.docTypeId"
                        *ngFor="let docType of docTypeList" (click)="onChangeDoctype(docType)">
                        <div class="selected-check">{{ docType.docTypeName }}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #errorduplicatedetails let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">{{msg}} Details</h5>
            <button type="button" class="close model_close_btn" (click)="   modalReference.close()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="pd_10 ">


            <div class="row selection-sec">
                <div class="grid_panel">
                    <app-basic-gridview [lstData]="errordata" [columnsToHide]="columnsToHide"
                        [showExcelDownloadOption]="true" [showSearchOption]="true" [showRecordsPerPageOption]="true"
                        [showPagination]="true" (cellClickEvent)="onGridCellClick($event)"
                        [hyperlinkCols]="hyperlinkCols" [columnsToExcludeFromExport]="[]">
                    </app-basic-gridview>
                </div>
            </div>
            <br />
        </div>


    </div>
</ng-template>

<ng-template #UrnList let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">URN pending list</h5>
            <button type="button" class="close model_close_btn" (click)="   modalReference.close()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="pd_10 ">

            <div>
                <p>{{urnmsg}}</p>
                <p>DOA details : <b>{{details}}</b></p>
            </div>
            <div class="row selection-sec">
                <div class="grid_panel">
                    <app-basic-gridview [lstData]="lst_urnpendinglist" [columnsToHide]="columnsToHide"
                        [showExcelDownloadOption]="true" [showSearchOption]="true" [showRecordsPerPageOption]="true"
                        [showPagination]="true" (cellClickEvent)="onGridCellClick($event)"
                        [hyperlinkCols]="hyperlinkCols" [columnsToExcludeFromExport]="[]">
                    </app-basic-gridview>
                </div>
            </div>
            <br />
        </div>


    </div>
</ng-template>
<ng-template #bulkupload let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Work Item Type : {{selectedDocumentType.docTypeName }}</h5>
            <button type="button" class="close model_close_btn" (click)="   modalReference.close()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="pd_10 ">
            <div class="col-lg-12 mb_20 align_right" style="float:right" (click)="downloadExcelTemplate()">
                <span class="download-template-wrp">
                    <span><i class="material-icons">file_download</i></span> Download Template
                </span>
            </div>
            <br />



            <div class="row cart-section">
                <div class="col-lg-10">
                    <div class="fileUploadTitle">
                        <span>Upload Excel File</span>
                    </div>
                    <div [style.width.%]="100">
                        <mat-toolbar class="matBG">
                            <input type="text" [hidden]="true">
                            <mat-label [attr.title]="fileTitle" class="file-names">{{selectedExcelFile}}</mat-label>
                            <button class="Mat_btn_Custom_Width" type="button" mat-flat-button color="primary"
                                (click)="invFileUpload.click()" [disabled]="!selectedDocumentType">
                                Choose file
                            </button>
                        </mat-toolbar>
                        <input [attr.type]="fileControlType" #invFileUpload (change)="onSelectExcelFile($event)"
                            hidden />
                    </div>




                </div>

                <div class="col-lg-2 pd_top_25">
                    <div class="textCenter">
                        <button class="waves-effect waves-light btn smallButton" (click)="saveDOAData()">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
            <br />
        </div>


    </div>
</ng-template>

<ng-template #UserDetailsModal let-modal>
    <div class="modal-content userselectcss">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Search User</h5>
            <button type="button" class="close model_close_btn" (click)="modalReference.close()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content userdetails">
                <div class="row justify_right">
                    <div class="col-lg-2 ">
                        <div class="textCenter">
                            <button id="userbtn" class=" btn smallButton" (click)="addclicked($event)">
                                {{Useraddbtn}}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row justify_space form-control-sec mrg_10" *ngIf="addclick">
                    <div class="col-lg-6 spacecss">
                        <mat-form-field [style.width.%]="100">
                            <mat-label for="login_id">Login Id</mat-label>
                            <input matInput value="" [(ngModel)]="loginidval" id="login_id">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 spacecss">
                        <mat-form-field [style.width.%]="100">
                            <mat-label for="name">Name</mat-label>
                            <input matInput value="" [(ngModel)]="Usernameval" id="name">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 spacecss">

                        <mat-form-field [style.width.%]="100">
                            <mat-label for="email">Email</mat-label>
                            <input matInput value="" [(ngModel)]="Emailval" id="email">
                        </mat-form-field>
                    </div>

                    <div class="col-lg-6">
                        <mat-form-field [style.width.%]="100">
                            <mat-label for="role_selection">Select Role</mat-label>
                            <mat-select [(ngModel)]="rolselval" id="role_selection">

                                <mat-option [value]="">
                                    --select--
                                </mat-option>
                                <mat-option [value]="doc.RoleId" *ngFor="let doc of RoleList">
                                    {{doc.RoleName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="row justify_center">
                        <div class="col-lg-2 pd_top_25">
                            <div class="textCenter">
                                <button class="waves-effect waves-light btn smallButton" (click)="Create_user()">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>


                </div>
                <div *ngIf="!addclick">
                    <app-basic-gridview [lstData]="ApproverData" [columnsToHide]="columnsToHide"
                        gridTitle="User Details" [showExcelDownloadOption]="true" [showSearchOption]="true"
                        [showRecordsPerPageOption]="true" [showPagination]="true"
                        (cellClickEvent)="onGridCellClick($event)" [hyperlinkCols]="hyperlinkCols"
                        [columnsToExcludeFromExport]="[]">
                    </app-basic-gridview>

                    <div class="row justify_center">
                        <div class="col-lg-2 pd_top_25">
                            <div class="textCenter">
                                <button class="waves-effect waves-light btn smallButton"
                                    (click)="modalReference.close()">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</ng-template>

<ng-template #Deletedoa_Modal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Delete DOA data </h5>
        </div>
        <div class="modal-body custom_modal_body" style="overflow-x: hidden; height: 200px;">
            <div class="model_content">

                <div style="text-align: left;">
                    <mat-label class="text-label" for="comments">Comment<span style="color: red;">*</span></mat-label>
                    <div class="cmnt_sec_h_100">
                        <div class="cmnt_textarea_sec" [ngClass]="isCommentExpand_deletedao?'expanded_textarea':''">
                            <span class="textarea_font_sec" title="Show list of restricted keywords"
                                (click)="showModal_gen(restrictedKeywordModal,'sm')">
                                <img src="../../../assets/img/transaction/info.png" alt="Info">
                            </span>
                            <span class="expand_textarea_sec" title="Max/Min"
                                (click)="isCommentExpand_deletedao = !isCommentExpand_deletedao">
                                <img src="../../../assets/img/transaction/expand.png" alt="Expand">
                            </span>
                            <span class="textarea_editor_main_sec">
                                <span class="words_count_limit">
                                    {{wordsTotal_deletedao}}
                                </span>
                            </span>

                            <textarea [(ngModel)]="Comment_deletedao" required maxlength="1000"
                                (blur)="checkRestrictedKeywords(Comment_deletedao,true)" class="cmnt_textarea"
                                [class.invalid]="Comment_deletedao==''" (keyup)="function(Comment_deletedao, 'del')"
                                id="comments"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer model_center_btn_part">
            <button type="button" class="btn smallButton" [disabled]="Comment_deletedao == ''"
                (click)="Raise_del_request()">
                Submit
            </button>
            <button type="button" class="btn resetButton" (click)="close_deletedao()">
                Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #restrictedKeywordModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Keyword Replacement Chart</h5>
            <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <div class="table_section">
                    <div class="table-responsive tablecss mt10">
                        <table class="table custom_table">
                            <thead>
                                <tr>
                                    <th>Keywords</th>
                                    <th>Auto Replacement</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of restrictedKeywords">
                                    <td>{{ item.restrict }}</td>
                                    <td>{{ item.replace }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>